<template>
<div class="container">
    <div class="box" :class="{'hidden': noMargin }">
        <div class="title">
           <span>{{boxTitle}}</span>
           <slot name="right" class="right"></slot>
        </div>
        <slot name="info"></slot>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    boxTitle: {
      type: String,
      default: () => ({})
    },
    noMargin: {
      type: Boolean,
      default: () => false
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.container{
    height: 100%;
    background-color: #f5f5f5;
    margin-bottom: 30px;
    .hidden{
        margin-bottom: 0 !important;
    }
    .box{
        // margin-bottom: 15px;
        box-sizing: content-box;
        background: #ffffff;
        padding: 15px 30px;
        border-radius: 5px;
        .red{
            color: red;
        }
        .title{
            display: flex;
            justify-content: space-between;
            span{
                font-weight: bold;
                margin-bottom: 60px;
            }
        }
        .info-column{
            height: 280px;
            display: flex;
            flex-direction: column;
            align-content: flex-start;
            flex-wrap: wrap;
            .row{
                width: 450px;
                height: 70px;
                display: flex;
                flex-shrink: 0;
                span{
                    &:nth-child(1){
                        color: grey;
                        display: inline-block;
                        flex: 2;
                    }
                    &:nth-child(2){
                        flex: 5;
                    }
                }
            }
        }
        .info-row{
            // width: 50%;
            display: flex;
            flex-direction: column;
            .row{
                width: 700px;
                display: flex;
                margin-bottom: 60px;
            }
            .column{
                width: 70%;
                display: flex;
                flex-direction: column;
                .block{
                    margin: 30px 0;
                    display: flex;
                    flex-wrap: wrap;
                    .item{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        margin: 0 30px 30px 0;
                        width: 120px;
                        height: 50px;
                        border-radius: 5px;
                        color: #ffffff;
                        background: rgb(80, 185, 218);
                        span{
                            position: absolute;
                            top: 120%;
                            left: 50%;
                            font-size: 20px;
                            font-weight: bold;
                            transform: translate(-50%,-50%);
                            color: #000;
                        }
                    }
                }

            }
            span{
                &:nth-child(1){
                    color: grey;
                    display: inline-block;
                    flex: 1;
                }
                &:nth-child(2){
                    flex: 5;
                }
            }
        }
        .info-box{
            width: 100%;
            display: flex;
            flex-direction: column;
            .row{
                margin-bottom: 30px;
            }
            .row-img{
                margin: 30px 15px 0 0;
                img{
                    width: 150px;
                }
            }
        }

        .row-line{
            display: flex;
            span{
                margin-right: 15px;
            }
            .textarea{
                width: 500px;
            }
        }
    }
}
</style>
